import APIDriver from './api/APIDriver'
const api = new APIDriver('companies')

const methods = {
    byState: (id) => {
        api.setBearerProtection();
        return api.get(`state/${id}`);
    },
    byCity: (id) => {
        api.setBearerProtection();
        return api.get(`city/${id}`);
    },
    get: (id) => {
        api.setBearerProtection();
        return api.get('', id);
    },
    list: () => {
        api.setBearerProtection();
        return api.getAll('');
    },
    create: (data) => {
        api.setBearerProtection();
        return api.post('', data);
    },
    update: (id, data) => {
        api.setBearerProtection();
        return api.patch('', id, data);
    },
    remove: (id) => {
        api.setBearerProtection();
        return api.delete('', id);
    }
}


export default methods;